import { render, staticRenderFns } from "./addWord.vue?vue&type=template&id=1b6a3e02&"
import script from "./addWord.vue?vue&type=script&lang=js&"
export * from "./addWord.vue?vue&type=script&lang=js&"
import style0 from "./addWord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports